import React from 'react';

const ImageScreen = ({ imageSrc, alt }) => (
    <img src={imageSrc} alt={alt} className="pa-module-image" />
);

export default ImageScreen;
